
export const SEARCH_TALENT_CAROUSEL_DEFAULT_BREAKPOINTS = {
    '300': {
      slidesPerView: 2,
    },
    '360': {
      slidesPerView: 3,
    },
    '540': {
      slidesPerView: 4,
    },
    '768': {
      slidesPerView: 6,
    },
    '912': {
      slidesPerView: 8,
    },
    '1220': {
      slidesPerView: 10,
    },
  };